
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { AGTestSuiteFeedbackConfig } from 'ag-client-typescript';

import CollapsibleSection from '@/components/CollapsibleSection.vue';
import Toggle from '@/components/toggle.vue';

@Component({
  components: {
    CollapsibleSection,
    Toggle
  }
})
export default class AGTestSuiteAdvancedFdbkSettings extends Vue {
  @Prop({required: true, type: Object})
  value!: AGTestSuiteFeedbackConfig | null;

  d_feedback_config: AGTestSuiteFeedbackConfig | null = null;

  @Watch('value')
  on_value_changed(new_value: AGTestSuiteFeedbackConfig, old_value: AGTestSuiteFeedbackConfig) {
    this.d_feedback_config = JSON.parse(JSON.stringify(new_value));
  }

  created() {
    this.d_feedback_config = JSON.parse(JSON.stringify(this.value));
  }
}
